import { Transaction } from 'dexie';
import { SCHEMAS } from './user.schema';
import { fetchRolesAndPermission, syncedDBModel, syncStateManager } from '..';

export interface DBMigration {
  version: number;
  schema: Record<string, string>;
  upgrade?: (tx: Transaction) => Promise<void>;
}
export const migrations: DBMigration[] = [
  { version: 1, schema: SCHEMAS.v1 },
  {
    version: 2,
    schema: SCHEMAS.v2,
    upgrade: async (tx) => {
      tx.on('complete', async () => {
        try {
          const userRolesAndPermissionCount = await tx
            .table('userRoles')
            .count();
          if (
            userRolesAndPermissionCount === 0 ||
            userRolesAndPermissionCount === null
          ) {
            fetchRolesAndPermission(null);
          }
        } catch (error) {
          fetchRolesAndPermission(null);
        }
      });
    },
  },
  { version: 3, schema: SCHEMAS.v3 },
  {
    version: 4,
    schema: SCHEMAS.v4,
  },
  {
    version: 5,
    schema: SCHEMAS.v5,
  },
  {
    version: 6,
    schema: SCHEMAS.V6,
    upgrade: async (tx) => {
      tx.on('complete', async () => {
        try {
          await syncedDBModel.resetLastSyncedAt();
          await syncStateManager.checkChanges();
        } catch (error) {
          fetchRolesAndPermission(null);
        }
      });
    },
  },
  {
    version: 7,
    schema: SCHEMAS.V6,
  },
  {
    version: 8,
    schema: SCHEMAS.V6,
    upgrade: async (tx) => {
      tx.on('complete', async () => {
        try {
          await fetchRolesAndPermission(null);
        } catch (error) {}
      });
    },
  },
  {
    version: 9,
    schema: SCHEMAS.v7,
  },
  {
    version: 10,
    schema: SCHEMAS.v8,
    upgrade: async (tx) => {
      // Clear old schools table data during migration
      try {
        const schoolsCount = await tx.table('schools').count();
        if (schoolsCount > 0) {
          await tx.table('schools').clear();
        }
      } catch (error) {
        // Schools table may not exist in some cases
      }

      tx.on('complete', async () => {
        try {
          // Reset sync to fetch all schools from backend
          await syncedDBModel.resetLastSyncedAt();
          await syncStateManager.checkChanges();
        } catch (error) {}
      });
    },
  },
];
